/* eslint-disable @typescript-eslint/no-explicit-any */

import * as React from 'react';

import PauseCircleFilled from '@mui/icons-material/PauseCircleFilled';
import PlayCircleFilledWhite from '@mui/icons-material/PlayCircleFilledWhite';
import Replay from '@mui/icons-material/Replay';
import cx from 'classnames';

import { IAudioPlayerColors, Icons } from '../types';
import PLAYER from './state/player';

// TODO: Restore makeStyles functionality

interface IAudioPlayControlProps {
    playerStatus: string;
    playerColors: IAudioPlayerColors;
    pauseAudio: () => void;
    playAudio: () => void;
    replayAudio: () => void;
    icons?: Icons;
    classNames?: any;
}

const AudioPlayControl: React.FunctionComponent<IAudioPlayControlProps> = ({
    playerStatus,
    pauseAudio,
    playAudio,
    replayAudio,
    icons = {},
    classNames = {},
}) => {
    const {
        PlayIcon = PlayCircleFilledWhite,
        ReplayIcon = Replay,
        PauseIcon = PauseCircleFilled,
    } = icons;
    // const classes = useComponentStyles({ playerColors });
    switch (playerStatus) {
        case PLAYER.STATUS.PLAY:
            return (
                <PauseIcon
                    fontSize="medium"
                    onClick={(e) => {
                        e.stopPropagation();
                        pauseAudio();
                    }}
                    className={cx(classNames.pauseIcon)}
                />
            );
        case PLAYER.STATUS.STOP:
            return (
                <ReplayIcon
                    fontSize="medium"
                    onClick={(e) => {
                        e.stopPropagation();
                        replayAudio();
                    }}
                    className={cx(classNames.replayIcon)}
                />
            );
        default:
            return (
                <PlayIcon
                    fontSize="medium"
                    onClick={(e) => {
                        e.stopPropagation();
                        playAudio();
                    }}
                    className={cx(classNames.playIcon)}
                />
            );
    }
};

export default React.memo(AudioPlayControl);
